// extracted by mini-css-extract-plugin
export var button = "Popup-module--button--5cb77";
export var close = "Popup-module--close--c0760";
export var slideIn = "Popup-module--slideIn--9233c";
export var title = "Popup-module--title--f9a63";
export var wrapper = "Popup-module--wrapper--4f868";